import WTPConverterPage from "./WTPConverterPage";

export default WTPConverterPage;
